import { MyStylus } from './components/my-stylus'
import "./styles/fonts.css";
import { YandexMetrika } from './components/YandexMetrika'



function App() {
  return (
      <div className="__MyStylus__">
        <YandexMetrika />
        <MyStylus />
      </div>
  )
}

export default App
